import React from 'react';
import { EmptyData } from '@components/molecules/EmptyData';

export const InvoicesPlaceholder: React.FC = () => {
  return (
    <div className="grid grid-cols-1 mt-4 h-full">
      <EmptyData description="Coming Soon" />
    </div>
  );
};
